import { resolveAuthHeaders } from "../utils/posSession";

// BUG-2594 / BUG-2595: the login is no longer read from the shared cookies alone. A cookie
// that names another user than the one who signed in to this POS (a CW Apps sign-in in the
// same browser) is not followed; see utils/posSession.js for the rules.
export const getOAuthHeaders = () => resolveAuthHeaders();

// The cookie-only read used before BUG-2594, kept for reference by the tests.
export const getCookieOAuthHeaders = () => {
    const rawCookie = document.cookie;
    const cookies = rawCookie.split('; ');
    let access_token;
    let email;
    let username;
    let Enterprise;
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].split('=');
        const name = cookie[0];
        const value = cookie[1];
        if (name.includes('accessToken')) {
            access_token = value;
        }
        if (name.includes('LastAuthUser')) {
            email = decodeURIComponent(value);
        }
        if (name === "username") {
            username = value;
        }
        if (name === "Enterprise") {
            Enterprise = value;
        }
    }

    const cookieNames = cookies.map((c) => c.split('=')[0]).filter(Boolean);
    // console.debug("[AUTH-DIAG] getOAuthHeaders", {
    //     cookieCount: cookies.length,
    //     cookieNames,
    //     rawCookieLength: rawCookie.length,
    //     hasAccessToken: !!access_token,
    //     hasEmail: !!email,
    //     hasUsername: !!username,
    //     hasEnterprise: !!Enterprise,
    //     hostname: window.location.hostname,
    //     protocol: window.location.protocol,
    //     pathname: window.location.pathname,
    //     isElectron: !!window.electronAPI,
    // });

    // Return headers if access token exists, regardless of expiry.
    // Response interceptors handle 401 → refresh → retry.
    if (access_token) {
        return {
            access_token: `bearer ${access_token}`,
            email: email,
            Enterprise: Enterprise,
            username: username,
        };
    }

    // No access token — truly unauthenticated
    //console.warn("[AUTH-DIAG] No access token found. Raw cookie string:", rawCookie.substring(0, 200));
    return undefined;
};

// BUG-2066: the "lock POS → Sign In" redirect used to interpolate
// authHeaders.username alone at each of the 6 lock-screen call sites — for a
// session whose identity lives only in the LastAuthUser cookie (→ email),
// that's empty, so the Authentication page's readonly username field renders
// blank. Falling back to email here, in one shared/testable place, closes
// that gap consistently instead of relying on 5 separate copy-pasted lines
// to each remember the fallback.
export function buildLockedSignInUrl(base, authHeaders) {
    const identity = authHeaders?.username || authHeaders?.email || "";
    return `${base}sign-in?username=${encodeURIComponent(identity)}&readOnly=true`;
}
